<script>
export default {
  name: 'FormAlert',
  props: ['errors'],
  data() {
    return {}
  },
  computed: {
    show() {
      return this.formErrors.length
    },
    formErrors() {
      return Object.values(this.errors).filter((error) => error)
    },
  },
}
</script>

<template>
  <b-alert
    v-if="show"
    show
    variant="danger"
  >
    <p><strong>Please correct the following errors</strong></p>
    <ul>
      <li
        v-for="(error, index) in formErrors"
        :key="index"
        aria-invalid="true"
      >
        {{ error }}
      </li>
    </ul>
  </b-alert>
</template>
